<ng-container thr-parent-form>
    <div class="row align-items-end">
        <div class="col-12 col-md-6 col-lg-5 col-xl-6">
            <label>{{ 'form.participant-type' | translate }}</label
            ><br />
            <mat-radio-group
                [name]="prefix + 'Nature'"
                [(ngModel)]="manager.nature"
                (ngModelChange)="onResize()"
                [required]="true"
                [disabled]="isDisabled"
            >
                <div class="row my-3 mb-sm-4">
                    <div class="col-5">
                        <mat-radio-button [name]="prefix + 'Natural'" color="blue-gray" [value]="Nature.NATURAL">
                            {{ 'form.natural' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-5">
                        <mat-radio-button [name]="prefix + 'Legal'" color="blue-gray" [value]="Nature.COMPANY">
                            {{ 'form.legal' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
        <div class="col-12 col-lg-7 col-xl-6" *ngIf="!manager.isLegalPerson">
            <div class="row mb-3 mb-sm-4">
                <div class="col-12 col-sm-auto mb-4 mb-sm-0 mb-lg-2 mr-sm-4">
                    <mat-slide-toggle
                        [name]="prefix + 'IsSpanish'"
                        color="blue-gray"
                        labelPosition="before"
                        [disabled]="isDisabled"
                        [(ngModel)]="manager.isSpanish"
                    >
                        {{ 'form.you-are-spanish' | translate }}
                    </mat-slide-toggle>
                </div>
                <div class="col-12 col-sm-auto">
                    <mat-slide-toggle
                        [name]="prefix + 'IsResident'"
                        color="blue-gray"
                        labelPosition="before"
                        [disabled]="isDisabled"
                        [(ngModel)]="manager.isResident"
                    >
                        {{ 'form.you-are-resident' | translate }}
                    </mat-slide-toggle>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12" *ngIf="manager.isLegalPerson">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Name'"
                    matInput
                    [placeholder]="'form.fullname-manager-legal' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="manager.name"
                    #nameCtrl="ngModel"
                />
                <mat-error *ngIf="nameCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-4" *ngIf="!manager.isLegalPerson">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Name'"
                    matInput
                    [placeholder]="'form.name-shareholder-legal' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="manager.name"
                    #nameCtrl="ngModel"
                />
                <mat-error *ngIf="nameCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-4" *ngIf="!manager.isLegalPerson">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Surname'"
                    matInput
                    [placeholder]="'form.surname-shareholder-legal' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="manager.surname"
                    #surnameCtrl="ngModel"
                />
                <mat-error *ngIf="surnameCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select
                    [name]="prefix + 'Citizenship'"
                    [placeholder]="'form.citizenship' | translate"
                    required
                    [disabled]="isDisabled || manager.isSpanish"
                    [(ngModel)]="manager.citizenship"
                    #citizenCtrl="ngModel"
                >
                    <ng-template ngFor let-country [ngForOf]="countries">
                        <mat-option
                            [value]="country.id.value"
                            *ngIf="(!manager.isSpanish && country.id.value !== 'ES') || manager.isSpanish"
                        >
                            {{ country.name }}
                        </mat-option>
                    </ng-template>
                </mat-select>
                <mat-error *ngIf="citizenCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select
                    [name]="prefix + 'DocumentType'"
                    [placeholder]="'form.document' | translate"
                    [disabled]="isDisabled"
                    [(ngModel)]="manager.docType"
                >
                    <ng-template ngFor let-type [ngForOf]="manager.allowedDocTypes">
                        <mat-option [value]="type">{{ 'form.document-types.' + type | translate }}</mat-option>
                    </ng-template>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <thr-full-data-input-document
                [prefix]="prefix"
                [docType]="manager.docType"
                [isDisabled]="isDisabled"
                [value]="manager.docId"
                (valueChange)="manager.docId = $event"
            ></thr-full-data-input-document>
        </div>
    </div>
    <ng-container *ngIf="manager.isLegalPerson">
        <div class="row">
            <div class="col-12">
                <h3 class="mat-subheading-1 text-blue font-weight-bold">
                    {{ 'full-data.administrator-legal-person'|translate }}
                </h3>
            </div>
            <div class="col-12 col-lg-7 col-xl-6">
                <div class="row mb-3 mb-sm-4">
                    <div class="col-12 col-sm-auto mb-4 mb-sm-0 mb-lg-2 mr-sm-4">
                        <mat-slide-toggle [name]="prefix + 'LegalIsSpanish'" color="blue-gray" labelPosition="before"
                                          [disabled]="isDisabled" [(ngModel)]="manager.legalIsSpanish">
                            {{ 'form.you-are-spanish'|translate }}
                        </mat-slide-toggle>
                    </div>
                    <div class="col-12 col-sm-auto">
                        <mat-slide-toggle [name]="prefix + 'LegalIsResident'" color="blue-gray" labelPosition="before"
                                          [disabled]="isDisabled" [(ngModel)]="manager.legalIsResident">
                            {{ 'form.you-are-resident'|translate }}
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input [name]="prefix + 'LegalCompany'" matInput [placeholder]="'form.society'|translate" required
                           [disabled]="isDisabled" [(ngModel)]="manager.legalCompany" #legalCompanyCtrl="ngModel">
                    <mat-error *ngIf="legalCompanyCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input [name]="prefix + 'LegalName'" matInput [placeholder]="'form.name-administrator'|translate" required
                           [disabled]="isDisabled" [(ngModel)]="manager.legalName" #legalNameCtrl="ngModel">
                    <mat-error *ngIf="legalNameCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input [name]="prefix + 'LegalSurname'" matInput [placeholder]="'form.surname-administrator'|translate" required
                           [disabled]="isDisabled" [(ngModel)]="manager.legalSurname" #legalSurnameCtrl="ngModel">
                    <mat-error *ngIf="legalSurnameCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select [name]="prefix + 'LegalCitizenship'" [placeholder]="'form.citizenship'|translate" required
                                [disabled]="isDisabled || manager.legalIsSpanish" [(ngModel)]="manager.legalCitizenship" #citizenCtrl="ngModel">
                        <ng-template ngFor let-country [ngForOf]="countries">
                            <mat-option [value]="country.id.value" *ngIf="(!manager.legalIsSpanish && country.id.value !== 'ES') || (manager.legalIsSpanish)">
                                {{ country.name }}
                            </mat-option>
                        </ng-template>
                    </mat-select>
                    <mat-error *ngIf="citizenCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select [name]="prefix + 'LegalDocumentType'" [placeholder]="'form.document'|translate" [disabled]="isDisabled" [(ngModel)]="manager.legalDocType">
                        <ng-template ngFor let-type [ngForOf]="manager.legalAllowedDocTypes">
                            <mat-option [value]="type">{{ 'form.document-types.' + type|translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6">
                <thr-full-data-input-document [prefix]="prefix" [name]="'LegalDocument'" [docType]="manager.legalDocType" [isDisabled]="isDisabled"
                                              [value]="manager.legalDocId" (valueChange)="manager.legalDocId = $event"></thr-full-data-input-document>
            </div>
        </div>
    </ng-container>
</ng-container>
